import React from "react";

function ColloidMillMachine() {
  return (
    <>
      <style>{`
      .technical-spec-section {
        margin: 40px 0;
        overflow-x: auto;
      }
      .technical-spec-section h4 {
        font-family: 'Oxygen', sans-serif;
        font-weight: bold;
        font-size: 24px;
        color: #000;
        margin-bottom: 20px;
      }
      .table {
        width: 100%;
        border-collapse: collapse;
        background: white;
      }
      .table-bordered {
        border: 1px solid #ddd;
      }
      .table-bordered td {
        border: 1px solid #ddd;
        padding: 12px 15px;
        font-size: 14px;
      }
      .table tbody tr:nth-child(even) {
        background-color: #f2f2f2;
      }
      .table td:first-child {
        font-weight: 600;
        width: 40%;
      }
    `}</style>

      <main id="primary" className="site-main">
        <div className="space-for-header"></div>

        {/* Breadcrumb Section */}
        <section
          className="tj-page-header section-gap-x"
          data-bg-image="assets/images/bg/pheader-bg.webp"
        >
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tj-page-header-content text-center">
                  <h1 className="tj-page-title">Colloid Mill Machine</h1>
                  <div className="tj-page-link">
                    <span><i className="fa-solid fa-home"></i></span>
                    <span><a href="/">Home</a></span>
                    <span><i className="fa-solid fa-arrow-right"></i></span>
                    <span><span>Colloid Mill Machine</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div
            className="page-header-overlay"
            data-bg-image="assets/images/shape/pheader-overlay.png"
          ></div>
        </section>

        {/* MAIN CONTENT */}
        <section className="tj-blog-section section-gap slidebar-stickiy-container">
          <div className="container">
            <div className="row row-gap-5">

              {/* LEFT CONTENT */}
              <div className="col-lg-8">
                <div className="post-details-wrapper">

                  {/* MAIN IMAGE CENTERED */}
                  <div
                    className="blog-images wow fadeInUp"
                    data-wow-delay=".1s"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    <div className="col-sm-6">
                      <img
                        src="assets/images/SD_PHRMA_ALL_MIX _JPGS/19.png"
                        alt="Colloid Mill Machine"
                      />
                    </div>
                  </div>

                  <h2 className="title title-anim">Colloid Mill Machine</h2>

                  <div className="blog-text">
                    <p className="wow fadeInUp" data-wow-delay=".3s">
                      The Colloid Mill Machine is designed for homogenization,
                      emulsification, mixing, and wet grinding processes across
                      pharmaceutical, food, chemical, and cosmetic applications.
                    </p>

                    <p className="wow fadeInUp" data-wow-delay=".4s">
                      Its high-speed rotor–stator assembly ensures particle size
                      reduction down to 5–10 microns, producing smooth, uniform
                      dispersions. Built with stainless steel contact parts, the
                      machine offers durability, hygiene, and excellent output.
                    </p>
                  </div>

                  {/* EXTRA IMAGES */}
                  <div className="images-wrap">
                    <div className="row">

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".3s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/19.png"
                            alt="Colloid Mill Side"
                          />
                        </div>
                      </div>

                      <div className="col-sm-6">
                        <div className="image-box wow fadeInUp" data-wow-delay=".5s">
                          <img
                            src="assets/images/SD_PHRMA_ALL_MIX _JPGS/20.png"
                            alt="Colloid Mill Closeup"
                          />
                        </div>
                      </div>

                    </div>
                  </div>

                  {/* TECHNICAL SPECIFICATIONS */}
                  <div className="technical-spec-section">
                    <h4>Technical Specification</h4>

                    <table className="table table-bordered">
                      <tbody>

                        <tr>
                          <td>Model</td>
                          <td>DPM-CM-30</td>
                          <td>DPM-CM-45</td>
                          <td>DPM-CM-60</td>
                        </tr>

                        <tr>
                          <td>Output Capacity</td>
                          <td>50–300 kg/hr</td>
                          <td>100–600 kg/hr</td>
                          <td>200–1200 kg/hr</td>
                        </tr>

                        <tr>
                          <td>Hopper Capacity</td>
                          <td>15 L</td>
                          <td>25 L</td>
                          <td>35 L</td>
                        </tr>

                        <tr>
                          <td>Rotor Speed</td>
                          <td>2800 RPM</td>
                          <td>2800 RPM</td>
                          <td>2800 RPM</td>
                        </tr>

                        <tr>
                          <td>Particle Reduction Size</td>
                          <td>5–10 microns</td>
                          <td>5–10 microns</td>
                          <td>5–10 microns</td>
                        </tr>

                        <tr>
                          <td>Motor Power</td>
                          <td>3 HP</td>
                          <td>5 HP</td>
                          <td>7.5 HP</td>
                        </tr>

                        <tr>
                          <td>Material of Construction</td>
                          <td colSpan="3">SS 304 / SS 316 Contact Parts</td>
                        </tr>

                        <tr>
                          <td>Dimensions (L × W × H)</td>
                          <td>600 × 450 × 1000 mm</td>
                          <td>700 × 500 × 1100 mm</td>
                          <td>850 × 550 × 1200 mm</td>
                        </tr>

                        <tr>
                          <td>Machine Weight</td>
                          <td>120 kg</td>
                          <td>160 kg</td>
                          <td>210 kg</td>
                        </tr>

                      </tbody>
                    </table>
                  </div>

                </div>
              </div>

              {/* RIGHT SIDEBAR */}
              <div className="col-lg-4 sidebar-container">
                <div className="tj-main-sidebar">

                  <div className="tj-sidebar-widget service-categories">
                    <h4 className="widget-title">Related Products</h4>
                    <ul>

                      <li>
                        <a href="/rapid-mixer-granulator">
                          Rapid Mixer Granulator (RMG)
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/roll-compactor-machine">
                          Roll Compactor Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                      <li>
                        <a href="/multi-mill">
                          Multi Mill Machine
                          <span className="icon"><i className="fa-solid fa-arrow-right"></i></span>
                        </a>
                      </li>

                    </ul>
                  </div>

                </div>
              </div>

            </div>
          </div>
        </section>

      </main>
    </>
  );
}

export default ColloidMillMachine;
